/* ============================================================
   Mango Swatches JS
   Handles PLP card swatch clicks + PDP swatch clicks
   Vanilla JS, no jQuery
   ============================================================ */
(function () {
  'use strict';

  /* Delegate all swatch clicks */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.mg-swatch');
    if (!swatch) return;
    e.preventDefault();

    var productId = swatch.dataset.productId;
    var colorName = swatch.dataset.color;
    var variantId = swatch.dataset.variantId;
    var context   = swatch.closest('.mg-swatches') && swatch.closest('.mg-swatches').dataset.context;

    /* Update active state */
    var container = swatch.closest('.mg-swatches__row');
    if (container) {
      container.querySelectorAll('.mg-swatch').forEach(function (s) {
        s.classList.remove('mg-swatch--active');
      });
    }
    swatch.classList.add('mg-swatch--active');

    /* Update color name label */
    var nameEl = document.getElementById('mg-color-name-' + productId);
    if (nameEl) nameEl.textContent = colorName;

    if (context === 'pdp') {
      /* PDP: fire the existing Impulse radio input for this variant */
      _triggerPDPVariant(variantId, colorName);
    } else {
      /* PLP: swap the card image */
      _swapCardImage(productId, swatch.dataset.swatchImg, variantId);
    }
  });

  /* ---- PDP: find + check the radio for this variant ---- */
  function _triggerPDPVariant(variantId, colorName) {
    /* Find the color radio whose value matches the color */
    var radios = document.querySelectorAll('input.variant__input--color-swatch');
    radios.forEach(function (radio) {
      if (radio.dataset.colorName === colorName) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input',  { bubbles: true }));
        }
      }
    });
  }

  /* ---- PLP: swap card image to show the hovered/clicked color ---- */
  function _swapCardImage(productId, swatchImg, variantId) {
    /* Find the product card by data-product-id */
    var card = document.querySelector('[data-product-id="' + productId + '"] .grid-product__image');
    if (!card) {
      card = document.querySelector('[data-product-id="' + productId + '"] .image-element');
    }
    if (!card) return;

    /* Get a larger version of the swatch image for the card */
    /* Swatch img URL is 60x60 — replace with 600x for the card */
    var cardImgUrl = swatchImg.replace('_60x60_crop_center', '_600x').replace('60x60', '600x');

    /* Fade swap */
    card.style.transition = 'opacity 0.2s';
    card.style.opacity = '0';
    setTimeout(function () {
      card.src = cardImgUrl;
      card.style.opacity = '1';
    }, 150);
  }

  /* ---- Sync PDP Mango swatches when Impulse variant changes ---- */
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    var variant = e.detail.variant;
    /* Find the color option value from the variant */
    var colorInput = document.querySelector('input.variant__input--color-swatch:checked');
    if (!colorInput) return;
    var colorName = colorInput.dataset.colorName || colorInput.value;

    /* Update active swatch */
    document.querySelectorAll('.mg-swatches--pdp .mg-swatch').forEach(function (s) {
      var isActive = s.dataset.color === colorName;
      s.classList.toggle('mg-swatch--active', isActive);
    });

    /* Update color name */
    var productSection = colorInput.closest('[data-product-id]');
    var productId = productSection ? productSection.dataset.productId : null;
    if (productId) {
      var nameEl = document.getElementById('mg-color-name-' + productId);
      if (nameEl) nameEl.textContent = colorName;
    }
  });

})();
